const messages = {
    en: {
        delivery: {
            product: {
                name: 'Product',
                title: 'Product management',
                subtitle: 'View, search, create, edit and delete Product',
                creating: 'Creating Product',
                editing: 'Editing Product',
                deleting: 'Deleting Product',
                showing: 'Showing Product',
                menu: 'Product',
                products: 'Products',
                search: 'Search',
                labels: {
                    name: 'Name',
                    shortName: 'shortName',
                    description: 'Description',
                    image: 'Image',
                    price: 'Price',
                    active: 'Active',
                    ingredients: 'Ingredients',
                    categories: 'Categories',
                    featured: 'Featured',
                    homeGallery: 'Home Gallery'
                },

            }
        }
    },
    es: {
        delivery: {
            product: {
                name: 'Product',
                title: 'Administración de Product',
                subtitle: 'Ver, buscar, crear, editar, y borrar Product',
                creating: 'Creando Product',
                editing: 'Modificando Product',
                deleting: 'Eliminando Product',
                showing: 'Detalles de Product',
                menu: 'Product',
                products: 'Productos',
                search: 'Buscar',
                labels: {
                    name: 'Nombre',
                    shortName: 'Nombre Corto',
                    description: 'Descripción',
                    image: 'Imagen',
                    price: 'Precio',
                    active: 'Activo',
                    ingredients: 'Ingredientes',
                    categories: 'Categorias',
                    featured: 'Destacado',
                    homeGallery: 'Galería principal'
                },

            }
        }
    },
    pt: {
        delivery: {
            product: {
                name: 'Product',
                title: 'Administração de Product',
                subtitle: 'Ver, buscar, criar, editar e usar Product',
                creating: 'Criando Product',
                editing: 'Edição Product',
                deleting: 'Apagando Product',
                showing: 'Detalhes do Product',
                menu: 'Product',
                products: 'Products',
                search: 'Search',
                labels: {
                    name: 'Nome',
                    shortName: 'shortName',
                    description: 'Descripción',
                    image: 'Imagen',
                    price: 'Precio',
                    active: 'Activo',
                    ingredients: 'Ingredients',
                    categories: 'Categorias',
                    featured: 'Destacado',
                    homeGallery: 'Galería principal'
                },

            }
        }
    }
}

export default messages
